import { defineAction } from '~/prix'
import { z } from 'zod'
import veterinaryExamCreateAction from './veterinaryExamCreate.action.json' with { type: 'json' }
import { veterinaryExamObject } from '../veterinaryExamObject'

const veterinaryExamCreateDefinition = defineAction({
  ...veterinaryExamCreateAction,

  input: veterinaryExamObject
    .pick({
      type: true,
      name: true,
      observations: true,
    })
    .extend({
      id: z.string().uuid().nullish(),
    }),
  output: z.object({
    id: veterinaryExamObject.shape.id,
  }),
})

export default veterinaryExamCreateDefinition
